var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubethumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 108,
    viewBox: "0 0 204 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 108,
    rx: 8,
    fill: "#EEF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182 100H124C125.677 85.93 138.02 75 153 75C153.755 75 154.504 75.024 155.24 75.0779C169.198 76.1086 180.41 86.6371 182 100Z",
    fill: "#A5F9A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137 100H33C36.0066 72.9856 58.1402 52 85 52C93.099 52 100.754 53.9099 107.6 57.3039C123.465 65.1965 134.903 81.1314 137 100Z",
    fill: "#A5F9A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31H21C21 27.8305 23.4817 25.2561 26.537 25.2561C27.4349 25.2561 28.2829 25.4761 29.0312 25.8771C30.7147 22.9534 33.7825 21 37.3118 21C40.7412 21 43.7467 22.8499 45.4552 25.6442C46.0787 25.3855 46.7646 25.2432 47.4754 25.2432C50.5183 25.2561 53 27.8176 53 31Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.633 67.1125V93.0496C69.633 96.7936 66.598 99.8287 62.854 99.8287H51.383C47.639 99.8287 44.604 96.7936 44.604 93.0496V67.1125C44.604 63.6792 47.1611 60.8353 50.4749 60.3892L52.9045 52.7817H61.2767L63.7621 60.3892C67.076 60.8353 69.633 63.6792 69.633 67.1125Z",
    stroke: "white",
    strokeWidth: 1.59319,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2217 52.4639H61.9561V44.9998H52.2217V52.4639Z",
    fill: "#245DFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.355 90.8985V66.0049H65.8721V90.8985C65.8721 93.6388 63.6576 95.8533 60.9173 95.8533H53.3098C50.5775 95.8533 48.355 93.6308 48.355 90.8985Z",
    fill: "#EEF4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2874 70.999H43.6812V85.3298H70.2874V70.999Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7393 76.5441V79.7862H58.4971V83.0283H55.255V79.7862H52.0049V76.5441H55.255V73.2939H58.4971V76.5441H61.7393Z",
    fill: "#245DFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3379 46.5444C54.3538 48.1376 54.3698 49.7308 54.3857 51.324",
    stroke: "#EEF4FF",
    strokeWidth: 0.796596,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0312 46.5444C57.0472 48.1376 57.0631 49.7308 57.079 51.324",
    stroke: "#EEF4FF",
    strokeWidth: 0.796596,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7148 46.5444C59.7308 48.1376 59.7467 49.7308 59.7626 51.324",
    stroke: "#EEF4FF",
    strokeWidth: 0.796596,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9414 70.6802H33.522V99.8276H43.9414V70.6802Z",
    fill: "#AEC5F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9414 75.9951H33.522V77.8512H43.9414V75.9951Z",
    fill: "#245DFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.522 70.6814L37.6722 60.2778H48.0917L43.9414 70.6814H33.522Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5223 70.6802H16.6504V99.8276H33.5223V70.6802Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5223 75.9951H16.6504V77.8512H33.5223V75.9951Z",
    fill: "#D0DFFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.473 92.7863C26.444 92.7863 28.0418 90.3897 28.0418 87.4332C28.0418 84.4768 26.444 82.0801 24.473 82.0801C22.5021 82.0801 20.9043 84.4768 20.9043 87.4332C20.9043 90.3897 22.5021 92.7863 24.473 92.7863Z",
    fill: "#D0DFFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.651 70.6806L8 60.3169H24.8719L33.5229 70.6806H16.651Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.651 57.5054L8 60.3174H24.8719L33.5229 57.5054H16.651Z",
    fill: "#D0DFFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.05 58.0657V46.6587H97.3933V58.0657C97.3933 59.1321 96.6616 60.0605 95.6245 60.3092L80.6934 63.8915C75.5948 65.115 72 69.6744 72 74.9176V98.9029C72 99.7852 72.7153 100.5 73.5976 100.5H141.846C142.728 100.5 143.443 99.7852 143.443 98.9029V74.918C143.443 69.6748 139.849 65.1152 134.75 63.8919L119.819 60.3094C118.782 60.0605 118.05 59.1323 118.05 58.0657Z",
    fill: "#245DFB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75 63.8917L119.819 60.3092C118.782 60.0603 118.05 59.1321 118.05 58.0657V46.6587H114.026V60.8828C114.026 61.9492 114.758 62.8768 115.795 63.1255L131.807 66.9679C136.272 68.0392 139.419 72.0313 139.419 76.622V98.9029C139.419 99.7852 138.704 100.5 137.822 100.5H141.846C142.728 100.5 143.443 99.7852 143.443 98.9029V74.918C143.443 69.6746 139.848 65.1152 134.75 63.8917Z",
    fill: "#4B7AFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.211 60.4031L109.009 81.7905C108.465 82.8283 106.978 82.8283 106.434 81.7905L95.2324 60.4031L95.6244 60.3092C96.6622 60.0593 97.3932 59.1319 97.3932 58.0657V46.6587H118.05V58.0657C118.05 59.1321 118.781 60.0595 119.819 60.3092L120.211 60.4031Z",
    fill: "#FFC0A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.819 60.3092C118.781 60.0593 118.05 59.1319 118.05 58.0657V46.6587H97.3936V55.6082C98.442 56.5044 99.4815 57.1949 100.344 57.5671C103.594 58.9689 109.491 59.1539 113.442 58.1233C113.738 58.046 114.027 58.2665 114.027 58.5726V60.8828C114.027 61.9492 114.758 62.8768 115.795 63.1255L118.451 63.7629L120.211 60.4029L119.819 60.3092Z",
    fill: "#FFAD85"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.057 7H104.144C99.8459 7 96.069 9.22696 93.9014 12.5895C93.566 13.1099 93.0232 13.4513 92.4139 13.5604C88.39 14.2809 85.3354 17.7972 85.3354 22.0286V35.1135H130.109V26.0517C130.109 15.5298 121.579 7 111.057 7Z",
    fill: "#0032C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.057 7H105.424C114.406 10.0871 124.654 17.6698 123.018 35.1133H130.108V26.0515C130.108 15.5298 121.579 7 111.057 7Z",
    fill: "#0029A3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.485 35.8957V42.5802C125.509 44.6418 130.312 42.0796 130.915 37.8158C131.573 33.1589 125.864 30.3277 122.485 35.8957Z",
    fill: "#FFAD85"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9566 35.8957V42.5802C89.9331 44.6418 85.1305 42.0796 84.5275 37.8158C83.8687 33.1589 89.5782 30.3277 92.9566 35.8957Z",
    fill: "#FFAD85"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.228 25.0991C122.863 24.9323 123.485 25.407 123.485 26.0639V41.9255C123.485 46.2502 118.173 51.6134 115.1 52.9396C111.354 54.5553 104.089 54.5553 100.344 52.9396C97.271 51.6134 91.9585 46.25 91.9585 41.9255V22.8802C91.9585 21.0734 93.4233 19.6084 95.2303 19.6084H101.23C101.704 19.6084 102.159 19.7897 102.505 20.1134C105.128 22.5659 108.37 24.3625 111.861 25.2183C115.254 26.051 118.851 25.9861 122.228 25.0991Z",
    fill: "#FFC0A0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158.544 60.1047C158.209 60.4401 158.116 60.9473 158.31 61.3803C160.181 65.563 162.451 69.8564 159.045 73.2622L154.262 78.0451C150.857 81.4507 146.563 79.1809 142.38 77.3101C141.947 77.1163 141.44 77.2089 141.105 77.5443L130.317 88.332C129.886 88.7632 129.894 89.4706 130.344 89.8827C139.478 98.2503 152.335 97.637 160.112 89.8594L170.86 79.1121C178.639 71.3328 179.316 58.5374 170.883 49.3437C170.471 48.8944 169.764 48.8857 169.332 49.3169L158.544 60.1047Z",
    fill: "#AEC5F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.881 49.3437C170.469 48.8944 169.762 48.8857 169.331 49.3169L167.948 50.6996C174.336 59.6296 173.182 71.0018 166.039 78.1449L155.292 88.8922C150.901 93.2827 144.892 95.3893 138.848 94.8871C146.387 97.3191 154.548 95.4223 160.111 89.8596L170.858 79.1123C178.637 71.333 179.314 58.5377 170.881 49.3437Z",
    fill: "#789FED"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.331 49.3165L158.543 60.1044C158.208 60.4398 158.115 60.9473 158.309 61.3801C159.13 63.2149 160.027 65.0708 160.489 66.864L173.918 53.4346C173.087 52.0199 172.081 50.6527 170.894 49.3567C170.477 48.9018 169.768 48.8801 169.331 49.3165Z",
    fill: "#98B5F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.918 53.4348C173.088 52.0201 172.082 50.6529 170.895 49.3569C170.478 48.9018 169.768 48.88 169.332 49.3165L167.949 50.6992C169.255 52.5243 170.24 54.4523 170.929 56.4245L173.918 53.4348Z",
    fill: "#789FED"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.104 77.5452L130.316 88.333C129.88 88.7696 129.902 89.4796 130.357 89.8963C131.652 91.0808 133.022 92.0843 134.441 92.9132L147.864 79.4905C146.071 79.0289 144.215 78.1318 142.38 77.311C141.947 77.1173 141.44 77.2098 141.104 77.5452Z",
    fill: "#98B5F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M162.733 29.2499H155.715C155.099 29.2499 154.599 28.7503 154.599 28.1338V21.1161C154.599 20.4996 154.1 20 153.483 20H146.366C145.749 20 145.25 20.4996 145.25 21.1161V28.1338C145.25 28.7503 144.75 29.2499 144.134 29.2499H137.116C136.5 29.2499 136 29.7495 136 30.366V37.4831C136 38.0996 136.5 38.5992 137.116 38.5992H144.134C144.75 38.5992 145.25 39.0988 145.25 39.7153V46.733C145.25 47.3495 145.749 47.8491 146.366 47.8491H153.483C154.1 47.8491 154.599 47.3495 154.599 46.733V39.7153C154.599 39.0988 155.099 38.5992 155.715 38.5992H162.733C163.349 38.5992 163.849 38.0996 163.849 37.4831V30.366C163.849 29.7495 163.349 29.2499 162.733 29.2499Z",
    fill: "#D0DFFC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5992 77.3214H94.0793C93.858 77.3214 93.6786 77.142 93.6786 76.9207V74.4008C93.6786 74.1794 93.4992 74 93.2778 74H90.7222C90.5008 74 90.3214 74.1794 90.3214 74.4008V76.9207C90.3214 77.142 90.142 77.3214 89.9207 77.3214H87.4008C87.1794 77.3214 87 77.5008 87 77.7222V80.2778C87 80.4992 87.1794 80.6786 87.4008 80.6786H89.9207C90.142 80.6786 90.3214 80.858 90.3214 81.0793V83.5992C90.3214 83.8206 90.5008 84 90.7222 84H93.2778C93.4992 84 93.6786 83.8206 93.6786 83.5992V81.0793C93.6786 80.858 93.858 80.6786 94.0793 80.6786H96.5992C96.8206 80.6786 97 80.4992 97 80.2778V77.7222C97 77.5008 96.8206 77.3214 96.5992 77.3214Z",
    fill: "#4B7AFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9277 34.2891V35.081",
    stroke: "#0029A3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M115.516 34.2891V35.081",
    stroke: "#0029A3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.896 43.668C106.389 44.9064 109.055 44.9064 111.548 43.668",
    stroke: "#0029A3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9492 30.1383C99.2687 29.3419 100.588 29.3419 101.908 30.1383",
    stroke: "#0032C7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M113.535 30.1383C114.855 29.3419 116.174 29.3419 117.494 30.1383",
    stroke: "#0032C7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.374 37.0584C172.584 37.0584 162.364 37.0384 159.554 36.9584C159.164 36.9484 158.904 36.5584 159.034 36.1884C159.494 34.9684 160.514 33.9584 161.744 33.5384C163.214 33.0384 164.954 33.3984 166.104 34.4484C167.234 32.0884 170.014 30.6384 172.594 31.0784C174.754 31.4484 176.604 33.0984 177.434 35.5384C177.694 36.2884 177.154 37.0584 176.374 37.0584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubethumbnail);
export default __webpack_public_path__ + "static/media/Youtube thumbnail.3b0fe203614d622183b5b245bde49f4f.svg";
export { ForwardRef as ReactComponent };